export const SET_CURRENT_COMPANY = "company/SET_CURRENT_COMPANY";
export const SET_ALLOWED_COMPANIES = "company/SET_ALLOWED_COMPANIES";
